import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { DateTimePicker } from '@mui/x-date-pickers'

const getFormatedDateTime = (date) => {
  return `${date.toLocaleDateString('en-US')} ${date.toLocaleTimeString('cs-CZ')}`
}

const DateTimePickerFilterInput = ({
  filter,
  // eslint-disable-next-line no-unused-vars
  selectedValues,
  handleSelectedValues,
  // eslint-disable-next-line no-unused-vars
  isSetToMidnight = false,
  sx,
}) => {
  const getEvalValue = (val) => {
    let rv = null
    if (val) {
      const d = new Date(val)
      rv = isNaN(d) ? null : d
    }
    return rv
  }

  const [open, setOpen] = useState(false)
  const [value, setValue] = useState(getEvalValue(selectedValues[filter.field]))
  const [confirmedValue, setConfirmedValue] = useState(getEvalValue(selectedValues[filter.field]))
  const [pickerKey, setPickerKey] = useState(0)

  const date = new Date()
  isSetToMidnight ? date.setHours(23, 55, 0, 0) : date.setHours(0, 0, 0, 0)

  useEffect(() => {
    if (value) {
      handleSelectedValues(value, { [filter.field]: getFormatedDateTime(value) }, 'set')
    } else {
      handleSelectedValues(value, { [filter.field]: null }, 'clear')
    }
  }, [confirmedValue])

  useEffect(() => {
    const date = getEvalValue(selectedValues[filter.field])
    if (date === null) {
      setValue(date)
      setPickerKey((prev) => prev + 1)
    }
  }, [selectedValues[filter.field]])

  return (
    <DateTimePicker
      key={pickerKey}
      label={filter.headerName}
      name={filter.field}
      ampm={false}
      referenceDate={date}
      value={value}
      open={open}
      onOpen={() => {
        setOpen(true)
      }}
      onChange={(newValue) => {
        setValue(newValue)
      }}
      onAccept={(v) => {
        setConfirmedValue(v)
      }}
      onClose={() => {
        setOpen(false)
      }}
      slotProps={{
        field: {
          clearable: true,
          readOnly: false,
          onClear: () => setOpen(false),
          onClick: () => setOpen(true),
        },
      }}
      sx={{ ...sx }}
      format="MMMM do HH:mm"
    />
  )
}

DateTimePickerFilterInput.propTypes = {
  filter: PropTypes.object,
  selectedValues: PropTypes.object,
  handleSelectedValues: PropTypes.func,
  isSetToMidnight: PropTypes.bool,
  sx: PropTypes.object,
}

export default DateTimePickerFilterInput
